import React from 'react';
import ActivationForm from './Activation/ActivationForm';
import PasswordReset from './PasswordReset/PasswordReset';
import RecoverEmail from './RecoverEmail/RecoverEmail';
import VerifyEmail from './VerifyEmail/VerifyEmail';
import SignInWithEmailLink from './SignInWithEmailLink/SignInWithEmailLink';

const actions = props => {
  let search = props.location.search;
  let params = new URLSearchParams(search);
  let action = params.get('mode');
  const code = params.get('oobCode');

  switch (action) {
    case 'clientActivation':
      return (
        <ActivationForm
          code={code}
          type="client"
          name={params.get('clientName')}
        />
      );
    case 'trainerActivation':
      return (
        <ActivationForm
          code={code}
          type="trainer"
          name={params.get('trainerName')}
        />
      );
    case 'resetPassword':
      return (
        <PasswordReset code={code} continueUrl={params.get('continueUrl')} />
      );
    case 'recoverEmail':
      return <RecoverEmail code={code} />;
    case 'verifyEmail':
      return (
        <VerifyEmail code={code} continueUrl={params.get('continueUrl')} />
      );
    case 'signIn':
      return(
        <SignInWithEmailLink code={code} continueUrl={params.get('continueUrl')}/>
      );
    default:
      break;
  }
};

export default actions;
